var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { ComputeStatus } from "@biggeo/bg-server-lib/studio";
import { ToastBadge } from "../icons/logos";
import { CircularLoading, Stack, Tooltip, Typography } from "../components";
import React from "react";
import { match } from "ts-pattern";
import { AcUnitOutline, LocalFireDepartment } from "../icons";
export const DataSourceStatus = ({ status, tooltip = false, }) => {
    const Field = (_a) => {
        var { label } = _a, props = __rest(_a, ["label"]);
        return (React.createElement(Stack, { flexDirection: "row", gap: 1, alignItems: "center" },
            React.createElement(Typography, { variant: "body3", fontWeight: "semibold" }, label),
            React.createElement(ToastBadge, Object.assign({}, props))));
    };
    const TooltipField = (_a) => {
        var { label } = _a, props = __rest(_a, ["label"]);
        return (React.createElement(Tooltip, { title: label },
            React.createElement("span", null,
                React.createElement(ToastBadge, Object.assign({}, props)))));
    };
    if (tooltip) {
        return match(status)
            .with(ComputeStatus.hot, () => (React.createElement(TooltipField, { label: "Always On", icon: LocalFireDepartment, color: "success" })))
            .with(ComputeStatus.cold, () => (React.createElement(TooltipField, { label: "Cold", icon: AcUnitOutline, color: "info" })))
            .with(ComputeStatus.loading, () => (React.createElement(TooltipField, { label: "Loading", icon: CircularLoading, color: "warning" })))
            .with(ComputeStatus.unloading, () => (React.createElement(TooltipField, { label: "Cold", icon: AcUnitOutline, color: "info" })))
            .otherwise(() => null);
    }
    return match(status)
        .with(ComputeStatus.hot, () => (React.createElement(Field, { label: "Always On", icon: LocalFireDepartment, color: "success" })))
        .with(ComputeStatus.cold, () => (React.createElement(Field, { label: "Cold", icon: AcUnitOutline, color: "info" })))
        .with(ComputeStatus.loading, () => (React.createElement(Field, { label: "Loading", icon: CircularLoading, color: "warning" })))
        .with(ComputeStatus.unloading, () => (React.createElement(Field, { label: "Cold", icon: AcUnitOutline, color: "info" })))
        .otherwise(() => null);
};
//# sourceMappingURL=DataSourceStatus.js.map